var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-1e9e2aaa": "",
    "data-v-304a6410": "",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon medium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0812 0.25H9.91849C8.27751 0.25 6.94724 1.58027 6.94724 3.22125V28.7787C6.94724 30.4197 8.27751 31.75 9.91849 31.75H22.0812C23.7222 31.75 25.0525 30.4197 25.0525 28.7787V3.22125C25.0525 1.58027 23.7222 0.25 22.0812 0.25Z",
    fill: "#429E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5225 4.17003V26.75C23.5227 26.8169 23.5097 26.8831 23.4843 26.9449C23.4589 27.0067 23.4216 27.0628 23.3745 27.1102C23.3273 27.1576 23.2713 27.1952 23.2096 27.2209C23.148 27.2466 23.0818 27.2599 23.015 27.26H8.98501C8.91819 27.2599 8.85205 27.2466 8.79038 27.2209C8.7287 27.1952 8.67269 27.1576 8.62556 27.1102C8.57843 27.0628 8.54109 27.0067 8.51569 26.9449C8.49029 26.8831 8.47731 26.8169 8.47751 26.75V4.17003C8.47731 4.10321 8.49029 4.03701 8.51569 3.97521C8.54109 3.91341 8.57843 3.85722 8.62556 3.80985C8.67269 3.76249 8.7287 3.72488 8.79038 3.69917C8.85205 3.67346 8.91819 3.66017 8.98501 3.66003H23.015C23.0818 3.66017 23.148 3.67346 23.2096 3.69917C23.2713 3.72488 23.3273 3.76249 23.3745 3.80985C23.4216 3.85722 23.4589 3.91341 23.4843 3.97521C23.5097 4.03701 23.5227 4.10321 23.5225 4.17003Z",
    fill: "#64AB88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 2.1427H13.9012C13.8349 2.1427 13.7714 2.11636 13.7245 2.06948C13.6776 2.02259 13.6512 1.959 13.6512 1.8927C13.6512 1.8264 13.6776 1.76281 13.7245 1.71592C13.7714 1.66904 13.8349 1.6427 13.9012 1.6427H18.1C18.1663 1.6427 18.2299 1.66904 18.2768 1.71592C18.3237 1.76281 18.35 1.8264 18.35 1.8927C18.35 1.959 18.3237 2.02259 18.2768 2.06948C18.2299 2.11636 18.1663 2.1427 18.1 2.1427Z",
    fill: "#224735"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6132 28.603H14.3865C14.2603 28.603 14.158 28.7053 14.158 28.8315V30.0698C14.158 30.196 14.2603 30.2983 14.3865 30.2983H17.6132C17.7394 30.2983 17.8417 30.196 17.8417 30.0698V28.8315C17.8417 28.7053 17.7394 28.603 17.6132 28.603Z",
    fill: "#224735"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1425 3.66003L8.47751 26.5225V22.9525L20.0075 3.66003H22.1425Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5225 4.755V6.5375L11.1375 27.26H10.0725L23.5225 4.755Z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.53fc6a0477168962fe4941b606683b09.svg";
export { ForwardRef as ReactComponent };